import React, { useEffect } from "react";
import { ApiCustomer } from "src/api/api_customer";
import { GetGeneralSettingsResponse } from "src/api/generated/frontend_customer_v1";

/** Data provided by the {@link SETTINGS_CONTEXT} */
export type SettingsContext = {
    /** The currently active settings */
    settings: GetGeneralSettingsResponse;

    /** Reload the user's information */
    reset: () => void;
};

/** {@link React.Context} to access {@link GetGeneralSettingsResponse} */
const SETTINGS_CONTEXT = React.createContext<SettingsContext>({
    settings: {
        dns_base_domain: "",
        public_origin: "",
        headscale_domains: [],
    },

    /**
     * Reset the settings
     */
    reset: () => {},
});
SETTINGS_CONTEXT.displayName = "SettingsContext";
export default SETTINGS_CONTEXT;

/**
 * The properties for {@link SettingsProvider}
 */
export type SettingsProviderProps = {
    /**
     * Children of the settings provider
     */
    children: React.ReactNode;
};

/**
 * The provider of a settings context
 */
export function SettingsProvider(props: SettingsProviderProps) {
    const [settings, setSettings] = React.useState<GetGeneralSettingsResponse | "loading">("loading");
    let fetching = false;

    /**
     * Fetch the settings
     */
    const fetchSettings = async () => {
        if (fetching) return;
        fetching = true;

        const res = await ApiCustomer.settings.getGeneral();
        setSettings(res);

        fetching = false;
    };

    useEffect(() => {
        fetchSettings().then();
    }, []);

    if (settings === "loading") {
        return <div>Loading ..</div>;
    }

    return (
        <SETTINGS_CONTEXT.Provider
            value={{
                settings,
                reset: fetchSettings,
            }}
        >
            {props.children}
        </SETTINGS_CONTEXT.Provider>
    );
}
